import { BusinessContext } from 'providers';
import { use } from 'react';

function useBusiness() {
  const data = use(BusinessContext);

  return data;
}

export default useBusiness;
